var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"col",staticClass:"flex flex-col relative px-2 items-center justify-center border-r-2 border-offwhite h-full",style:('width: 300px;')},_vm._l((_vm.tasks),function(item){return _c('task',{key:item.id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }